import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { tap, delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class AuthService {

    isUserLoggedIn: boolean = false;

    login(userName: string, password: string): Observable<any> {
        if (userName == 'megaautos21@gmail.com' && password == 'megaautossj')
            this.isUserLoggedIn = true;

        localStorage.setItem('isUserLoggedIn', this.isUserLoggedIn ? "true" : "false");

        return of(this.isUserLoggedIn).pipe(
            delay(1000),
            tap(val => { })
        );
    }

    logout(): void {
        this.isUserLoggedIn = false;
        localStorage.removeItem('isUserLoggedIn');
    }

    constructor() { }
}